import * as React from 'react';
import { MainPadding } from '../../components/MainPadding';
import {
    Paper,
    List,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
    Button,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import { serviceLocator } from '../../services';
import { Link } from 'react-router-dom';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { Breadcumb } from '../../components/Breadcumb';

import ListItemButton from "@mui/material/ListItemButton";

const agencyService = serviceLocator.getAgencyService();

interface State {
    agencies: Array<any>,
    activeAgencies: boolean
}

export class AgenciesList extends React.Component<any,State>{

    private editLinks: Record<string, React.ComponentType<any>> = {};
    private createLink = React.forwardRef((props: any, ref: any) => <Link ref={ref} to="/agencies/create/" {...props} />);

    state = {
        agencies: [],
        activeAgencies: true
    }

    componentDidMount(){
        this.refreshList();
    }

    refreshList = async () =>{
        const { agencies } = await agencyService.listAgencies(this.state.activeAgencies);
        this.setState({ agencies });
    }

    getEditLink = (identifier: string) => {
        if (!this.editLinks[identifier]) {
            this.editLinks[identifier] = React.forwardRef((props: any, ref: any) => (
                <Link ref={ref} to={`/agencies/${encodeURIComponent(identifier)}/`} {...props} />
            ));
        }
        return this.editLinks[identifier];
    }

    handleActiveAgenciesChange = (e: any) => {
        this.setState({activeAgencies: e.currentTarget.checked}, ()=>{
            this.refreshList();
        });
    }

    render(){
        return (
            <MainPadding>
                <Breadcumb items={[
                    { label:"Agencies" }
                ]} />
                <br />
                <div style={{ padding: '16px 0' }}>
                <Button variant="contained" color="primary" nativeButton={false} component={this.createLink}>New</Button>
                     {/* &nbsp; <Button variant="text" size="small" color="default" onClick={this.handleBatchBuildClick}>Batch Build</Button> */}
                </div>
                <FormControlLabel
                    label="Active" control={<Checkbox checked={this.state.activeAgencies} onChange={this.handleActiveAgenciesChange}  />} />
                <Paper>
                    <List component="nav">
                        { (this.state.agencies||[]).map((agency: any, i: number) => {
                            return (
                                <ListItemButton
                                    key={agency.identifier}
                                    component={this.getEditLink(agency.identifier)}
                                    divider={i < this.state.agencies.length - 1}>
                                    <ListItemText primary={`${agency.name}`} secondary={`${agency.identifier}`} />
                                    {/* <ListItemSecondaryAction>
                                        <IconButton  data-key={agency.identifier}>
                                            <MoreVertIcon />
                                        </IconButton>
                                    </ListItemSecondaryAction> */}
                                </ListItemButton>
                            );
                        }) }
                    </List>
                </Paper>
            </MainPadding>
        );
    }
}